
export const groupDetailsStep=[
    {
    target: ".j_g_bBtn",
    content: "Click here to go back to the list of all Security Groups.",
    placement: "bottom",
  },

  {
    target: ".j_g_acc",
    content:
      "Once roles are applied then security group strength is shown here according to the weight of roles applied.",
    placement: "bottom",
  },
        {
    target: ".j_g_det",
    content:
      "In this section fill the necessary information like name and description.",
    placement: "bottom",
  },

  {
    target: ".j_g_nam",
    content: "Enter a unique name for the Security Group. This is required.",
    placement: "bottom",
  },
  
  {
    target: ".j_g_desc",
    content: "Provide a brief description of this group’s purpose.",
    placement: "bottom",
  },

    {
    target: ".j_g_save",
    content: "Click to save the Security Group without closing the form.",
    placement: "left",
  },

  {
    target: ".j_g_saCl",
    content: "Click to save and close the form when you're done.",
    placement: "left",
  },

]
export const groupRolesSteps=[
    {
    target: ".j_g_bBtn",
    content: "Click here to go back to the list of all Security Groups.",
    placement: "bottom",
  },

  {
    target: ".j_g_acc",
    content:
      "Once roles are applied then security group strength is shown here according to the weight of roles applied.",
    placement: "bottom",
  }, 
  {
    target: ".j_g_roles",
    content:
      "In this section choose roles that are needed to keep in the security group being created.",
    placement: "bottom",
  },
  {
    target: '.j_srch',
    content: 'You can search for roles by name here to quickly find what you need.',
    placement: 'bottom',
  },
  {
    target: '.j_fil',
    content: 'Use these filters to narrow down roles by business units, geography, etc.',
    placement: 'bottom',
  },
  {
    target: '.j_u_rT_assigned',
    content: 'Assigned roles for the user will appear here.',
    placement: 'bottom',
  },
  {
    target: '.j_u_rT_available',
    content: 'Click here to view and assign new roles from the available ones.',
    placement: 'bottom',
  },
  {
    target: '.j_g_rt_copy',
    content: 'Copy roles from an existing user or security group to save time.',
    placement: 'top',
  },
  {
    target: '.j_g_rT_asBtn',
    content: 'Use this button to assign roles to the user manually.',
    placement: 'top',
  },

    {
    target: ".j_g_save",
    content: "Click to save the Security Group without closing the form.",
    placement: "left",
  },

  {
    target: ".j_g_saCl",
    content: "Click to save and close the form when you're done.",
    placement: "left",
  },
]